import React from 'react';

// Curated organic blob outlines (viewBox 0 0 100 100) — soft, slightly wobbly
// "hand-made" bubbles drawn behind a scene's text. One shape is picked per scene
// (seed = scene index) so each page differs, but deterministically so the
// on-screen book and the printed PDF match exactly. MUST stay identical to the
// copy in server/services/bookPdf.js (TEXT_BUBBLE_PATHS / TEXT_BUBBLE_ROT).
export const TEXT_BUBBLE_PATHS = [
  'M 93.76 49.87 C 94.10 60.38, 89.29 74.61, 82.16 81.77 C 75.03 88.92, 61.44 92.95, 50.96 92.80 C 40.48 92.66, 27.00 88.03, 19.28 80.89 C 11.56 73.76, 4.73 60.58, 4.64 50.00 C 4.54 39.41, 11.02 24.58, 18.72 17.41 C 26.43 10.23, 40.65 6.73, 50.88 6.94 C 61.11 7.15, 72.98 11.51, 80.13 18.67 C 87.27 25.82, 93.42 39.35, 93.76 49.87 Z',
  'M 94.61 50.93 C 94.46 61.20, 87.97 73.23, 80.36 80.50 C 72.75 87.76, 59.20 94.60, 48.98 94.53 C 38.77 94.45, 26.05 87.55, 19.07 80.04 C 12.08 72.53, 7.23 59.72, 7.08 49.49 C 6.93 39.26, 10.89 26.08, 18.17 18.64 C 25.46 11.19, 40.27 4.80, 50.78 4.84 C 61.30 4.88, 73.96 11.20, 81.26 18.89 C 88.57 26.57, 94.77 40.66, 94.61 50.93 Z',
  'M 95.26 48.87 C 95.20 59.40, 88.94 73.52, 81.27 81.17 C 73.59 88.82, 59.83 94.80, 49.20 94.77 C 38.57 94.74, 24.45 88.39, 17.49 80.99 C 10.53 73.59, 7.00 60.69, 7.44 50.38 C 7.87 40.07, 13.11 26.38, 20.10 19.12 C 27.09 11.86, 39.14 7.01, 49.38 6.82 C 59.63 6.64, 73.94 10.99, 81.58 17.99 C 89.23 25.00, 95.31 38.34, 95.26 48.87 Z',
  'M 93.60 49.99 C 93.42 60.22, 88.30 72.01, 80.92 79.43 C 73.54 86.85, 59.49 94.45, 49.32 94.49 C 39.15 94.53, 27.35 87.18, 19.90 79.66 C 12.45 72.14, 4.75 59.30, 4.62 49.38 C 4.49 39.47, 11.57 27.20, 19.10 20.15 C 26.63 13.10, 39.31 7.45, 49.79 7.10 C 60.27 6.74, 74.67 10.89, 81.97 18.04 C 89.27 25.19, 93.77 39.76, 93.60 49.99 Z',
];
const TEXT_BUBBLE_ROT = [-2, 1.5, -1, 2];

// Hand-made off-white bubble sitting behind scene text. `seed` (the scene index)
// picks a stable shape + small rotation. Styling lives in App.css (.text-bubble).
export default function TextBubble({ seed = 0 }) {
  const n = TEXT_BUBBLE_PATHS.length;
  const i = ((Number(seed) % n) + n) % n;
  const rot = TEXT_BUBBLE_ROT[i % TEXT_BUBBLE_ROT.length];
  return (
    <svg
      className="text-bubble"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{ transform: `translate(-50%, -50%) rotate(${rot}deg)` }}
    >
      <path d={TEXT_BUBBLE_PATHS[i]} />
    </svg>
  );
}
